/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApplicationScope } from './ApplicationScope';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeFromJSONTyped,
    ApplicationScopeToJSON,
} from './ApplicationScope';
import type { Role } from './Role';
import {
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
} from './Role';

/**
 * 
 * @export
 * @interface TenancyRole
 */
export interface TenancyRole {
    /**
     * 
     * @type {ApplicationScope}
     * @memberof TenancyRole
     */
    tenant?: ApplicationScope;
    /**
     * 
     * @type {Array<Role>}
     * @memberof TenancyRole
     */
    readonly roles?: Array<Role>;
}

/**
 * Check if a given object implements the TenancyRole interface.
 */
export function instanceOfTenancyRole(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenancyRoleFromJSON(json: any): TenancyRole {
    return TenancyRoleFromJSONTyped(json, false);
}

export function TenancyRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenancyRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenant': !exists(json, 'tenant') ? undefined : ApplicationScopeFromJSON(json['tenant']),
        'roles': !exists(json, 'roles') ? undefined : ((json['roles'] as Array<any>).map(RoleFromJSON)),
    };
}

export function TenancyRoleToJSON(value?: TenancyRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenant': ApplicationScopeToJSON(value.tenant),
    };
}

